import { render, staticRenderFns } from "./InvitationToBuildProfile.vue?vue&type=template&id=cfb7b8f6&scoped=true"
import script from "./InvitationToBuildProfile.vue?vue&type=script&lang=js"
export * from "./InvitationToBuildProfile.vue?vue&type=script&lang=js"
import style0 from "./InvitationToBuildProfile.vue?vue&type=style&index=0&id=cfb7b8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb7b8f6",
  null
  
)

export default component.exports